import { useEffect, useState } from 'react'

/*
 * Returns the id of the section currently under the reading line (35% down the viewport).
 * Ids must be passed in page order. Pass an empty list to switch tracking off.
 */
export const useActiveSection = (ids: Array<string>, offsetRatio = 0.35): string | null => {
    const [active, setActive] = useState<string | null>(null)
    const key = ids.join(',')

    useEffect(() => {
        if (!key) {
            setActive(null)
            return
        }

        const sectionIds = key.split(',')
        let frame = 0

        const update = () => {
            frame = 0

            const line = window.innerHeight * offsetRatio
            let current: string | null = null

            for (const id of sectionIds) {
                const element = document.getElementById(id)

                if (element && element.getBoundingClientRect().top <= line) current = id
            }

            setActive(current)
        }

        const schedule = () => {
            if (!frame) frame = window.requestAnimationFrame(update)
        }

        update()
        window.addEventListener('scroll', schedule, { passive: true })
        window.addEventListener('resize', schedule)

        return () => {
            window.removeEventListener('scroll', schedule)
            window.removeEventListener('resize', schedule)

            if (frame) window.cancelAnimationFrame(frame)
        }
    }, [key, offsetRatio])

    return active
}
